import { supabase, getCurrentUser } from '../lib/supabase';
import type { LoginCredentials, AuthResponse } from '../types/auth';

export const authService = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const { data: authData, error: signInError } = await supabase.auth.signInWithPassword({
      email: credentials.email,
      password: credentials.password,
    });

    if (signInError) {
      throw new Error(`Sign in failed: ${signInError.message}`);
    }

    if (!authData.user) {
      throw new Error('No user data returned from authentication');
    }

    const user = await getCurrentUser();
    if (!user) {
      throw new Error('Failed to fetch user profile after authentication');
    }

    return {
      user,
      token: authData.session?.access_token || ''
    };
  },

  logout: async (): Promise<void> => {
    // Use the scope option to clear all storage data
    const { error } = await supabase.auth.signOut({ 
      scope: 'global' // This will clear all sessions across all tabs/windows
    });
    
    if (error) {
      throw new Error(`Sign out failed: ${error.message}`);
    }
    
    // Add a small delay to ensure the signOut operation completes
    await new Promise(resolve => setTimeout(resolve, 100));
  }
};
